import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import classNames from "classnames";
const StyledTypography = styled("span")(({ variant, color, type }) => {
    const base = {
        ...(variant && typography[variant]),
        ...(type && typography[type]),
        color: color && palette[color],
    };
    return base;
});
export function GrTypography({ variant, type, color, children, className, style }) {
    return (_jsx(StyledTypography, { className: classNames("GrTypography", className), variant: variant, type: type, color: color, style: style, children: children }));
}
//# sourceMappingURL=GrTypography.js.map